import styled from 'styled-components'
import { fontSizes } from 'syf-component-library/defaultTheme'
import { SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal'

export const SlideInModalPortalWrapper = styled(SlideInModalPortal)`
  svg {
    box-sizing: unset;
  }
  h1 {
    font-size: ${fontSizes.root}px;
  }
  > div {
    overscroll-behavior: none;
  }
`
